import { installStorageGuard } from "./safeStorage";

// First module the app evaluates (see main.tsx): every later storage write,
// ours or a library's, is quota-safe before any of them runs.
installStorageGuard();
